/* eslint-disable @typescript-eslint/no-explicit-any */
import { VStack, Skeleton, HStack, Button } from '@chakra-ui/react';
import { MainTemplate } from '../../templates/MainTemplate';
import { useTheme } from '../../contexts/ThemeProvider';
import { FaFrown } from 'react-icons/fa';
import { Label } from '../../components/atoms/Label';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CardNotification } from './components/CardNotifications';
import { useNavigate } from 'react-router-dom';
import { useNotificationsInfinity } from '@/service/club/hooks';

export function NotificationPage() {
  const { id, colors } = useTheme();

  const { isLoading, isFetching, fetchNextPage, hasNextPage, data } = useNotificationsInfinity(id, {
    per_page: 10,
  });

  const navigation = useNavigate();

  const onHandleClick = async (discount: string) => {
    navigation(`/vantagens/detalhes/local/${discount}`);
  };

  return (
    <MainTemplate>
      <VStack
        id="scrollableDiv"
        align={'self-start'}
        width="100%"
        marginBottom={'100px'}
        paddingTop={'20px'}
        spacing={6}
      >
        <HStack padding={'0px 20px'} alignSelf={'flex-start'}>
          <Label>Notificações</Label>
        </HStack>
        <InfiniteScroll
          dataLength={Number(data && data.pages ? data.pages.flat().length : 0)}
          next={fetchNextPage}
          style={{
            width: '100%',
          }}
          scrollableTarget="scrollableDiv"
          hasMore={!!hasNextPage}
          loader={
            <VStack padding={'0px 20px'} width={'100%'} align={'center'} justify={'center'} spacing={4}>
              {new Array(8).fill(0).map((_, i) => (
                <Skeleton key={i} width={'100%'} borderRadius={'20px'} height="130px" />
              ))}
            </VStack>
          }
        >

          <VStack width={'100%'} align={'center'} justify={'center'} spacing={4}>
            {(isFetching || isLoading) && (
              <VStack padding={'0px 20px'} width={'100%'} align={'center'} justify={'center'} spacing={4}>
                {new Array(8).fill(0).map((_, i) => (
                  <Skeleton key={i} width={'100%'} borderRadius={'6px'} height="130px" />
                ))}
              </VStack>
            )}

            {!isLoading &&
              (data?.pages.flat()?.length ?? 0) > 0 &&
              (data?.pages.flat() || []).map((a: any) => {
                return (
                  <>
                    {a.results.map((b: any) => {
                      return (
                        <VStack padding="0px 20px" width={'100%'} key={b.id} spacing={2}>
                          <CardNotification {...b} onHandleClick={() => onHandleClick(b.discount)} />
                        </VStack>
                      );
                    })}
                  </>
                );
              })}
            {!isLoading && data?.pages.flat()[0]?.count === 0 && (
              <VStack spacing={5} paddingTop={'50px'}>
                <FaFrown size="50px" color={colors.primaryColor} />
                <Label textAlign={'center'}>Nenhuma notificação disponível no momento.</Label>

                <Button
                  borderColor={colors.primaryColor}
                  variant="outline"
                  color={colors.primaryColor}
                  onClick={() => navigation('/vantagens')}
                >
                  Ver vantagens
                </Button>
              </VStack>
            )}
          </VStack>
        </InfiniteScroll>
      </VStack>
    </MainTemplate>
  );
}
